import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

interface GetFullyBookedClassesParams {
  sessionId: string;
  format: 'csv';
}

export const getFullyBookedClassesAPI = async (
  params: GetFullyBookedClassesParams,
) => {
  const response = await baseAPI.get<string>(
    '/dashboard/capacity/full-classes',
    {
      params,
      responseType: 'text',
    },
  );
  return response.data;
};

export const useGetFullyBookedClasses = (
  params: GetFullyBookedClassesParams,
) => {
  return useQuery({
    queryKey: [KEYS.FULLY_BOOKED_CLASSES, params.sessionId],
    queryFn: () => getFullyBookedClassesAPI(params),
    enabled: !!params.sessionId,
  });
};
